module.exports = __webpack_public_path__ + "img/banner1.3ae29680.png";